import { Button, Grid, Stack,IconButton, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import DatePickerComponent from '../common/components/dateRangePicker'
import { CustomButton } from '../common/components/customButton'
import SearchComponent from '../common/components/searchComponent'
import { mapStateToProps } from '../../redux/reducers'
import { PropTypes } from "prop-types";
import * as actionTypes from "../../redux/actionTypes/csaSignup";
import CsaSignupStatusDetails from "./csaSignupStatusDetails";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import CloseIcon from '@mui/icons-material/Close';
import AuditIcon from '@mui/icons-material/History';
import CsaSignupStatusHistory from './csaSignupStatusHistory';
import ModalComponent from "../common/components/modal";
import moment from 'moment'
import { connect } from "react-redux";
import { refreshKey } from "../../redux/actionTypes/administration";
import { useState } from 'react'
import { CalculateUserTzToUTCTz, popUpAlert, removeSpecialCharacter } from '../../utils/globalMethods'
import { useNavigate } from 'react-router-dom'
import TableComponent from '../common/components/table'
import SelectDropdown from '../common/selectdropdown-component'
import CommonLoading from '../common/components/commonLoading'

let language = localStorage.getItem("selectedLanguage");
if (language === null) {
  language = "en-US";
}
let languageCode = language.substring(0, 2);

function createData(id,isAction,startDate,endDate,setId,vendorId,clientId,shareId,vendorName, chosenNam,paymentType,shareName,shareCost,apprvlStatus,submittedDate, 
  agrmntAppId,clientNam,clientEmail,phoneNumber,lastUpdtUidNam,rejectedDate,address1,address2,city,state,zipcode,day,
  openTime,closeTime,dsc,cancelNotes,cancelESign,cancelDate,clientPreferdEmail,clientPreferdPhone,
  row
  ) {
    return {
      id,
      isAction,
      startDate, //: paymentType === "MNTHLY" ? moment(startDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(startDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
      endDate, //: paymentType === "MNTHLY" ? moment(endDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(endDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
      setId,
      vendorId,
      clientId,
      shareId,
      vendorName,
      chosenNam,
      paymentType,
      shareName,
      shareCost,
      apprvlStatus,
      submittedDate :moment(submittedDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
      agrmntAppId:agrmntAppId,
      clientNam :clientNam,
      clientEmail:clientEmail,
      phoneNumber:phoneNumber,
      lastUpdtUidNam:lastUpdtUidNam,
      rejectedDate:moment(rejectedDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
      address1:address1,
      address2:address2,
      city:city,
      state:state,
      zipcode:zipcode,
      day : day,
      openTime : openTime,
      closeTime : closeTime,
      dsc:dsc,
      cancelNotes:cancelNotes,
      cancelESign:cancelESign,
      cancelDate:moment(cancelDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
      clientPreferdEmail,
      clientPreferdPhone,
      row      
    };
  }

const CsaSignupStatusList = (props) => {

    const {csaSignupStatusTotal ,setcsaSignupStatusTotal } = props;
    // ,setSearch,search,tableSort,setTableSort ,  showLoader,setShowLoader} = props; setExpand,expand

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState();
    const [showLoader, setShowLoader] = useState(true);
    const [rows, setRows] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState({ name: "", values: "All Status", isActive: 1 });
    const [onUpdate, setOnUpdate] = useState({});
    const [size, setSize] = useState(10);
    const [from, setFrom] = useState(0);
    const [columns, setColumns] = useState([]);
    const [tableSort, setTableSort] = useState({"submittedDate":"DESC"});
    const [expand, setExpand] = useState(false);
     // eslint-disable-next-line no-unused-vars 
    const [csaSignupStatusList, setCsaSignupStatusList] = useState(0);
    const [search, setSearch] = useState("");
    const [status] = useState("");
    const [resetDate, setResetDate] = useState(false);
    const [statusList] = useState([
      { name: "", values: "All status", isActive: 1 },
      { name: "APPRVD", values: "Approved", isActive: 1 },
      { name: "CANCLD", values: "Cancelled", isActive: 1 },
      { name: "DRAFT", values: "Pending", isActive: 1 },
      { name: "REJCTD", values: "Rejected", isActive: 1 }]);

      const [showAuditModal, setShowAuditModal] = useState(false);
      const [dateRangePickerLabel] = useState("Select Date");
      const [filterData, setFilterData] = useState({
        startDate: null,
        endDate: null,  
      });
      const filterHandleChange = (date) => {
        setFilterData({
          ...filterData,
          endDate: date?.[0]?.endDate ? CalculateUserTzToUTCTz(date?.[0]?.endDate) : null,
          startDate:date?.[0]?.startDate ? CalculateUserTzToUTCTz(date?.[0]?.startDate) : null,
        })
      }

    useEffect(() => {
        const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
        if(props?.allowedRoles) {
          const checkRole = props?.allowedRoles.find((role) => userRole?.Role?.includes(role));
          if(!checkRole) {
            navigate('/dtahip');
            return;
          }
        }
        const payload = {
          "nam": search?.trim(),
          "shareId": 0,
          "addressId": 0,
          "shareStatus": status,
          "signupStatus": selectedStatus.name == "all" ? "" : selectedStatus.name,
          "addressType": "delivery",
          "vendorNamSort":"vendorName" in tableSort ? tableSort["vendorName"]:"",
          "shareNamSort":"shareName" in tableSort ? tableSort["shareName"]:"",
          "clientNameSort":"clientNam" in tableSort ? tableSort["clientNam"]:"",
          "apprvlStatusSort": "apprvlStatus" in tableSort ? tableSort["apprvlStatus"] : "",
          "startDate": filterData.startDate ? moment(filterData.startDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "endDate": filterData.endDate ? moment(filterData.endDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "submittedDateSort":"submittedDate" in tableSort ? tableSort["submittedDate"]:"",
          "size": size,
          "from": from,
        }
        props.getCsaSignupStatusList(payload);
    }, [size, from, status, selectedStatus, props.csaSignup.refreshKey, search, filterData, tableSort]);
    
    useEffect(() => {
        if (props.csaSignup?.csaSignupStatusList?.csaSignupStatusList?.length) {
             setCsaSignupStatusList(props?.csaSignup?.csaSignupStatusList?.csaSignupStatusList);
           } else {
            setCsaSignupStatusList([]);
           }
    }, [props?.csaSignup?.csaSignupStatusList?.csaSignupStatusList]);

    useEffect(() => {
        const { list, total, loading } = props.csaSignup.csaSignupStatusList;
        let data = [];
        setRows([]);
        setTimeout(() => {
            list.forEach(element => {
                data.push(createData(element.id, element?.isAction, element?.startDate, element?.endDate, element.setId, element.vendorId, element.clientId, element.shareInfo?.id, element?.vendorName, element?.chosenNam, element?.paymentType, element?.shareInfo?.nam, element?.shareInfo?.shareCost,
                    element?.apprvlStatus, element?.submittedDate, element?.agrmntAppId, element?.clientNam, element?.clientEmail,
                    element?.phoneNumber, element?.lastUpdtUidNam, element?.rejectedDate,
                    element?.shareInfo?.pickupInfo?.address1 ? element?.shareInfo?.pickupInfo?.address1 : element?.shareInfo?.deliveryInfo?.address1,
                    element?.shareInfo?.pickupInfo?.address2 ? element?.shareInfo?.pickupInfo?.address2 : element?.shareInfo?.deliveryInfo?.address2,
                    element?.shareInfo?.pickupInfo?.city ? element?.shareInfo?.pickupInfo?.city : element?.shareInfo?.deliveryInfo?.city,
                    element?.shareInfo?.pickupInfo?.state ? element?.shareInfo?.pickupInfo?.state : element?.shareInfo?.deliveryInfo?.state,
                    element?.shareInfo?.pickupInfo?.zipcode ? element?.shareInfo?.pickupInfo?.zipcode : element?.shareInfo?.deliveryInfo?.zipcode,
                    element?.shareInfo?.pickupInfo?.day, element?.shareInfo?.pickupInfo?.openTime, element?.shareInfo?.pickupInfo?.closeTime,
                    element?.shareInfo?.dsc, element?.cancelNotes, element?.cancelESign, element?.cancelDate,
                    element?.clientPreferdEmail, element?.clientPreferdPhone, element
                ));
            });
            setRows(data);
        }, 300);
        handleColumns();
        setcsaSignupStatusTotal(total);
        setShowLoader(loading);

    }, [props.csaSignup.csaSignupStatusList]);

    const handleSearch = (e) => {
        setExpand(false);
        setShowLoader(true);
        setSearch(e?.target?.value?.toLowerCase());
        resetSize();
    };

    const resetSize = () => {
        setFrom(0);
        setSize(10);
    }

    const handleNext = (page, rowSize) => {
        (size != rowSize) && setSize(rowSize);
        setFrom(rowSize * page);
    };
    const handleApproveStatus = (row) => {
        const payload = {
            "id": row?.id,
            "setId": row?.setId,
            "shareId": row?.shareId,
            "clientId": row?.clientId,
            "vendorId": row?.vendorId,
            "apprvlStatus": "APPRVD",
            "paymentType": row?.paymentType,
            "languageCode": languageCode,

        }
        props.updateApproveCsaSignupStatus(payload);
    }


    const handleApprove = (row) => {
        popUpAlert({
            title: "Are you sure?",
            text: "Do you want to approve this CSA Signup.",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, approve it!",
            closeOnConfirm: false,
            onConfirmed: true,
            handleConfirm: () => handleApproveStatus(row),
        });
    }

    const handleRejectStatus = (row) => {
        const payload = {
            "id": row?.id,
            "setId": row?.setId,
            "shareId": row?.shareId,
            "clientId": row?.clientId,
            "vendorId": row?.vendorId,
            "apprvlStatus": "REJCTD",
            "paymentType": row?.paymentType,
            "languageCode": languageCode,

        }
        props.updateApproveCsaSignupStatus(payload);
    }
    const handleReject = (row) => {
        popUpAlert({
            title: "Are you sure?",
            text: "Do you want to reject this CSA Signup.",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, reject it!",
            closeOnConfirm: false,
            onConfirmed: true,
            handleConfirm: () => handleRejectStatus(row),
        });
    }
    const handleSort = (item) => {
        let sortitem = {};
        if (item.sort == "" || item.sort == "DESC") {
            sortitem[item.id] = "ASC";
        } else {
            sortitem[item.id] = "DESC";
        }
        setTableSort(sortitem);
    };

    const handleOnHistoryAction = (row) => {
        setShowAuditModal(true);
        setOnUpdate(row);
    }

    const handleColumns = () => {
        const headers = [
            { id: "details", label: "Details" },
            {
                id: "vendorName", label: "Vendor Name",
                sort: "vendorName" in tableSort ? tableSort["vendorName"] : "",
                cell: (item) => {
                    let status = " ";
                    if (item.paymentType === "MNTHLY") {
                        status = "Monthly"
                        return (<><p>
                            {removeSpecialCharacter(item.vendorName)}</p>
                            {status && <span className="badge badge-primary">{status}</span>}
                        </>)
                    }
                    else {
                        status = "Daily"
                        return (<><p>
                            {removeSpecialCharacter(item.vendorName)}</p>
                            {status && <span className="badge badge-grey">{status}</span>}
                        </>
                        )
                    }
                }
            },
            {
                id: "clientNam",
                label: "Client Name",
                sort: "clientNam" in tableSort ? tableSort["clientNam"] : "",
                cell: (item) => {
                    const fullName = item?.clientNam ? item?.clientNam : '-';
                    const nameArray = fullName.split(' ');
                    const firstName = nameArray[0];
                    return <>
                        <div  >
                            {fullName}
                        </div>
                    </>;
                }
            },
            {
                id: "chosenNam",
                label: "Preferred Name",
                cell: (item) => {
                    return item?.chosenNam ? item?.chosenNam : <div style={{ paddingLeft: "35px" }}>{"-"}</div>
                }
            },
            {
                id: "shareName",
                label: "Share Name",
                sort: "shareName" in tableSort ? tableSort["shareName"] : "",
            },
            {
                id: "shareCost",
                label: "Amount",
                cell: (item) => {
                    return <div>{"$ " + item.shareCost}</div>
                }
            },
            {
                id: "apprvlStatus",
                label: "CSA Signup status",
                sort: "apprvlStatus" in tableSort ? tableSort["apprvlStatus"] : "",
                cell: (item) => {
                    let status = "";
                    if (item.apprvlStatus == "DRAFT") {
                        status = "Pending";
                        return (<div style={{ color: "#456F8F", fontWeight: "bold" }}> {status} </div>)
                    }
                    else if (item.apprvlStatus == "REJCTD") {
                        status = "Rejected";
                        return (<div style={{ color: "#dc3545", fontWeight: "bold" }}> {status} </div>)
                    }

                    else if (item.apprvlStatus == "APPRVD") {
                        status = "Approved";
                        return (<div style={{ color: "#006e52", fontWeight: "bold" }}> {status} </div>)
                    }

                    else if (item.apprvlStatus == "CANCLD") {
                        status = "Cancelled";
                        return (<div style={{ color: "#dc3545", fontWeight: "bold" }}> {status} </div>)
                    }
                }
            },
            {
                id: "startDate",
                label: "Share Start Date",
                cell: (item) => {
                    const date = (item?.startDate === "Invalid date") ? <div style={{ paddingLeft: "40px" }}>{"-"}</div> : ((item?.paymentType === "MNTHLY") ? moment(item.startDate).format('MMMM YYYY') : moment(item.startDate).format('MM/DD/YYYY'));
                    return <div>{date}</div>
                }
            },
            {
                id: "endDate",
                label: "Share End Date",
                cell: (item) => {
                    const date = (item?.endDate === "Invalid date") ? <div style={{ paddingLeft: "40px" }}>{"-"}</div> : ((item?.paymentType === "MNTHLY") ? moment(item.endDate).format('MMMM YYYY') : moment(item.endDate).format('MM/DD/YYYY'));
                    return <div>{date}</div>
                }
            },
            {
                id: "rejectedDate",
                label: "Approve/Reject Date",
                cell: (item) => {
                    const date = (item?.rejectedDate === "Invalid date") ? <div style={{ paddingLeft: "40px" }}>{"-"}</div> : item?.rejectedDate;
                    return <div>{date}</div>
                }
            },
            {
                id: "submittedDate",
                label: "Signup Submitted Date",
                sort: "submittedDate" in tableSort ? tableSort["submittedDate"] : "",
            },
            {
                id: "action",
                label: "Action",
                cell: (item) => {
                    if (item?.isAction === 'Y') {
                        if (item?.apprvlStatus === "DRAFT") {
                            return (
                                <div style={{ paddingLeft: "12px" }}>
                                    <div style={{ margin: '8px 0px 8px 0px' }} >
                                        <Button variant="outlined" color="success" onClick={() => handleApprove(item)} startIcon={<DoneOutlinedIcon />} style={{ textTransform: 'none', width: "100px" }}>Approve</Button>
                                    </div>
                                    <div style={{ margin: '8px 0px 8px 0px' }}>
                                        <Button variant="outlined" color="error" onClick={() => handleReject(item)} startIcon={<CloseIcon />} style={{ textTransform: 'none', width: "100px" }}>Reject</Button>
                                    </div>
                                </div>
                            )
                        } else if (item?.apprvlStatus === "APPRVD") {
                            return <div style={{ padding: "12px" }}>
                                <div style={{ margin: '8px 0px 8px 0px' }}>
                                    <Button variant="outlined" color="error" onClick={() => handleReject(item)} startIcon={<CloseIcon />} style={{ textTransform: 'none', width: "100px" }}>Reject</Button>
                                </div>
                            </div>
                        }
                    } else {
                        return (<>
                            <div style={{ paddingLeft: "40px" }}> - </div>
                        </>);
                    }
                }
            },
            {
                id: "",
                label: "History",
                cell: (item) => {
                    return (
                        <IconButton aria-label="audit" onClick={() => handleOnHistoryAction(item)}>
                            <AuditIcon />
                        </IconButton>
                    )
                }
            }
        ];
        setColumns(headers);
    };

    const renderDetails = (row) => {
        return (
          <CsaSignupStatusDetails
            row={row}
          />
    
        );
    };
    
    const renderModal = () => {
        return (<CsaSignupStatusHistory  row={onUpdate}/>
        )
    }



    useEffect(() => {
        const { loading } =  props?.csaSignup?.exportCsaSignupStatus;
        setIsLoading(loading);
     }, [props?.csaSignup?.exportCsaSignupStatus?.exportCsaSignupStatus]);

    const exportData = () => {
        setIsLoading(true);
        const payload = {
          "nam": search?.trim(),
          "shareId": 0,
          "addressId": 0,
          "shareStatus": status,
          "signupStatus": selectedStatus.name == "all" ? "" : selectedStatus.name,
          "addressType": "delivery",
          // "startDate": moment(filterData.startDate.unix() * 1000).format("MM/DD/YYYY"),
          // "endDate": moment(filterData.endDate.unix() * 1000).format("MM/DD/YYYY"),
          "startDate": filterData.startDate ? moment(filterData.startDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "endDate": filterData.endDate ? moment(filterData.endDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "size": 10000,
          "from": 0,
        }
    
        props.exportCsaSignupStatus(payload);
    }

  return (
    <Grid className="container-block" rowSpacing={2}>
        {isLoading && <CommonLoading />}
        {showAuditModal &&
          <ModalComponent
            shown={showAuditModal}
            close={() => {
              setShowAuditModal(false);
            }}
            title="CSA Signup Status HISTORY"
            modalBody={renderModal}
            size={"xl"}
            dialogClassName={"modal-90w"}
            label={"CSA Signup Status HISTORY"}
          />
        }
        <Grid container  sx={{ backgroundColor: "#DBE8DF" }} direction={"row"}   >
            <Grid container item columnSpacing={{ xs: 1, sm: 2, md: 3 }} p={2} >
                <Grid item xs={6} md={3}>
                    <Typography variant='subtitle1' sx={{ fontFamily: "texta-bold" }}>
                    Filter by Submitted Date
                    </Typography>
                    <DatePickerComponent label={dateRangePickerLabel} selectedDateObj={(date) => { filterHandleChange(date, "", "date") }} resetDate={resetDate} />
                </Grid>
                            
                <Grid item xs={6} md={3}>
                    <Typography variant='subtitle1' sx={{ fontFamily: "texta-bold" }}>
                    Filter by Status
                    </Typography>
                    <SelectDropdown
                      id="statusFilter"
                      value= {selectedStatus}
                      isSearch={true}
                      style={{ width: "75%"}}
                      variant="outlined"
                      options={statusList}
                      onChange={(item) =>{
                        setSelectedStatus(item)   
                        setShowLoader(true); 
                        setFrom(0);                       
                      }}
                    >
                    </SelectDropdown>
                </Grid>
                <Grid container item xs="auto" p={3} alignItems={"center"} >
                    <Stack direction='row' spacing={2} justifyContent="flex-end">
                    <Grid item>
                        <CustomButton variant="outlined" sx={{ fontWeight: "bold" }} 
                        onClick={()=>{
                            setSearch("");
                            setExpand(false);
                            setSelectedStatus({ name: "", values: "All Status", isActive: 1 });
                            // props.refreshKey();
                            setShowLoader(true);
                            setFilterData('');
                            setResetDate(preDate=>
                              !preDate)
                            setTableSort({"submittedDate":"DESC"});
                            setShowLoader(true);
                            setFrom(0);
                            setSize(10);
                         }}
                        startIcon={<i className="fa fa-refresh" aria-hidden="true"></i>}>
                        Reset
                        </CustomButton>
                    </Grid>
                    <Grid item>
                        <CustomButton variant="outlined" sx={{ fontWeight: "bold" }} startIcon={<i className="fa fa-download" aria-hidden="true"></i>}
                         onClick={exportData}
                        >
                        Export
                        </CustomButton>
                    </Grid>
                    </Stack>
                </Grid>
            </Grid>
      </Grid>
      <Grid container pt={1} justifyContent={'flex-end'}> 
        <SearchComponent
            placeholder={"Name,Email,Agreement ID"}
            handleChange={handleSearch}
            searchText={search}
            />
      </Grid>
      <Grid pt={1}>
        <Grid item>
            <TableComponent
                columns={columns}
                rows={rows}
                showDetails={true}
                expand={expand}
                renderDetails={renderDetails}
                handlePagination={handleNext}
                total={csaSignupStatusTotal}
                page={Math.floor(from / size)}
                rowsPerPage={size}
                handleSort={handleSort}
                dataLoading={showLoader}
                />
        </Grid>
      </Grid>
    </Grid>
  )
}

CsaSignupStatusList.propTypes = {
    refreshKey: PropTypes.func.isRequired,
    getCsaSignupStatusList: PropTypes.func.isRequired,
    csaSignup: PropTypes.object.isRequired,
    exportCsaSignupStatus: PropTypes.func.isRequired,
    updateApproveCsaSignupStatus: PropTypes.func.isRequired,
    allowedRoles: PropTypes.array,
    userAuth : PropTypes.object,
    setcsaSignupStatusTotal:PropTypes.func,
    csaSignupStatusTotal:PropTypes.number,
    // search:PropTypes.func,
    // setSearch: PropTypes.func,
    // tableSort:PropTypes.func,
    // setTableSort:PropTypes.func,
    // setShowLoader:PropTypes.bool,
    // showLoader:PropTypes.bool,
    // setExpand: PropTypes.bool,
    // expand: PropTypes.bool,


  
}

function mapDispatchToProps(dispatch) {
    return {
      refreshKey: () => dispatch(refreshKey()),
      getCsaSignupStatusList: (payload) => dispatch(actionTypes.getCsaSignupStatusList(payload)),
      exportCsaSignupStatus: (payload) => dispatch(actionTypes.exportCsaSignupStatus(payload)),
      updateApproveCsaSignupStatus: (payload) => dispatch(actionTypes.updateApproveCsaSignupStatus(payload))
  
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CsaSignupStatusList);